import React from "react";
import styles from "./index.module.scss";

interface ListCardToolsProps {
    children?: React.ReactNode;
}

export function ListCardTools({ children }: ListCardToolsProps) {
    return <div className={styles.root}>{children}</div>;
}
